<app-efa-sub-list [previous]="false">
  <a actions class="link" routerLink="../">
    {{ 'organization.done' | cxTranslate }}
  </a>
</app-efa-sub-list>
